export default __webpack_public_path__ + "static/media/Next.c58da16a.svg";